var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contacts-card",class:{
    'contacts-card_active': _vm.isActive,
    'contacts-card_with-hover': _vm.withHover,
  }},[_c('div',{staticClass:"contacts-card__content"},[_c('div',{staticClass:"contacts-card__label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),_vm._t("content",function(){return [(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()]})],2),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }